import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CaisseListComponent} from './caisse-list.component';
import {CaisseService} from './caisse.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {AdLibraryModule} from 'ad-library';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CaissePipesModule} from '../../../common/pipes/caisse-pipes.module';
import {NgxBootstrapSharedModule} from '../../../shared/ngxbootstrap-shared.module';
import {CaisseFormComponent} from './caisse-form.component';

@NgModule({
  declarations: [CaisseListComponent, CaisseFormComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, AdLibraryModule, DragDropModule, CaissePipesModule, NgxBootstrapSharedModule],
  exports: [CaisseListComponent, CaisseFormComponent],
  providers: [CaisseService],
})
export class CaisseModule {
}
